import { render, staticRenderFns } from "./tab-switcher.vue?vue&type=template&id=63b1334c&"
import script from "./tab-switcher.vue?vue&type=script&lang=ts&"
export * from "./tab-switcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports